export default __webpack_public_path__ + "static/media/brand.ad3805e0.svg";